


import Vue from 'vue'
import App from './App'
import router from './router'
import Common from './common/js/common.js'
import Util from './common/js/util.js'
import store from './vuex/index.js'










import AlertPlugin from 'vux/src/plugins/alert/index.js'
import ConfirmPlugin from 'vux/src/plugins/confirm/index.js'
import ToastPlugin from 'vux/src/plugins/toast/index.js'
import WechatPlugin from 'vux/src/plugins/wechat/index.js'
import LoadingPlugin from 'vux/src/plugins/loading/index.js'


Vue.use(AlertPlugin)
Vue.use(ConfirmPlugin)
Vue.use(ToastPlugin)
Vue.use(WechatPlugin)
Vue.use(LoadingPlugin)




Vue.config.productionTip = false




Vue.directive('drop', {
inserted: function (el) {


el.onblur = function () {
setTimeout(function () {
var scrollHeight = document.documentElement.scrollTop || document.body.scrollTop || 0;
window.scrollTo(0, Math.max(scrollHeight - 1, 0));
}, 100)

}

}
})

router.beforeEach(async (to, from, next) => {



if (localStorage.getItem('Archives')) {
store.commit('editStateFn', {
field: 'Archives',
val: localStorage.getItem('Archives'),
})
}


if (Util.getCookie('uuid')) {
if (!localStorage.getItem('uuid')) {
localStorage.setItem('uuid', Util.getCookie('uuid'))
}
next()
} else {
if (localStorage.getItem('uuid')) {
Util.setCookie('uuid', localStorage.getItem('uuid'), 365)
next()
} else {
const uuid = Util.getUuid()
Util.setCookie('uuid', uuid, 365)
localStorage.setItem('uuid', uuid)
next()
}
}








})

new Vue({
el: '#app',
router,
store,
components: {
App
},



template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js